import { FC, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StardustRushContext } from 'contexts/stardustRush/stardustRush';
import { Countdown } from 'components/Countdown';
import { getTimeLeft } from 'helpers/timer';

export const StardustRushTimer: FC = () => {
  const { t } = useTranslation();

  const { stardustRushCMSData } = useContext(StardustRushContext);

  const timeLeft = useMemo(
    () => Math.max(getTimeLeft(stardustRushCMSData?.endDate || ''), 0),
    [stardustRushCMSData?.endDate]
  );

  return (
    <Countdown timeLeft={timeLeft} dual>
      {({ days, hours, minutes }) => (
        <>
          <span>
            {days}
            {t('timerShort.d')}
          </span>
          :
          <span>
            {hours}
            {t('timerShort.h')}
          </span>
          :
          <span>
            {minutes}
            {t('timerShort.m')}
          </span>
        </>
      )}
    </Countdown>
  );
};
